import React, { createContext, useContext, useState } from 'react';
const SelectedStopoverContext = /*#__PURE__*/createContext(null);
export function useSelectedStopover() {
  const selectedStopover = useContext(SelectedStopoverContext);
  if (selectedStopover !== false && typeof selectedStopover !== 'object') {
    throw new Error('No selectedStopover found');
  }
  return selectedStopover;
}
const SelectedStopoverProvider = ({
  children
}) => {
  const initArray = [...Array(10)].map(() => false);
  const [isChecked, setIsChecked] = useState(initArray);
  return /*#__PURE__*/React.createElement(SelectedStopoverContext.Provider, {
    value: [isChecked, setIsChecked]
  }, children);
};
export default SelectedStopoverProvider;